export default __webpack_public_path__ + "static/media/21g28mmvb.4784b703.jpeg";